import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../services/permission.service';
import { Permissions } from '../enums/permissions.enum';

export const PermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const required: Permissions = route.data['permission'];

  if (!required || permissionService.has(required)) {
    return true;
  }

  router.navigateByUrl('/dashboard/manager-dashboard');
  return false;
};
